import React, {useEffect, useState} from "react";
import Wrapper from "components/blocks/Wrapper";
import Container from "components/blocks/Container";
import DefaultLayout from "layouts/Default";
import MyBreadcrumbs from "components/MyBreadcrumbs";
import cn from "clsx";
import Link from "next/link";
import {wrapper} from "lib/store";
import {useRouter} from "next/router";
import {Grid, List, ListItem, Typography} from '@mui/material'
import MyInput from "components/MyInput";
import {makeStyles} from '@mui/styles';
import {useDispatch, useSelector} from "react-redux";
import {getPaginatedBrandsThunk} from "lib/features/brandSlice";
import {serverSideTranslations} from "next-i18next/serverSideTranslations";
import {useTranslation} from "next-i18next";
import config from "../../../data/config.json";
import {checkMobile} from "../../../utils/helper";

const BRANDS_ROUTE = config.brand.route


const BREAD_ROUTE = [
    {label: 'Home', href: '/', isActive: false},
    {label: 'brands_all_brands', href: '/allBrands', isActive: true},
]

export const getServerSideProps = wrapper.getServerSideProps(store => async (context) => {
    const {
        query,locale,
    } = context
    let page = 1
    let sort = {}
    let businessTypes = []
    const filter = {
        businessTypes
    }
    return {
        props: {
            page,
            ...(await serverSideTranslations(locale, ['home', 'common']))
        }
    }
})

const useStyles = makeStyles((theme) => ({
    root: {
        display: "flex",
        flexDirection: "row",
        padding: 0
    },
    list: {
        paddingLeft: 10,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'center',
        paddingTop: 'unset',
        marginBottom: 20
    },
    mobileList: {
        width: 'auto',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'center',
        paddingTop: 'unset',
        marginBottom: 20
    }
}));

export default function AllBrands({page}) {
    const router = useRouter()
    const classes = useStyles();
    let brands = useSelector(state => state.brand.brands)

    const dispatch = useDispatch()
    const { t } = useTranslation()
    const [loaded, setLoaded] = useState(false)
    async function initBrand() {
        const sort = {}
        const page = 1
        const filter = {}
        await dispatch(getPaginatedBrandsThunk({page, filter, sort}))
    }
    useEffect(() => {
        console.log('at allbrands: ', brands.length)
        if (brands[0].name === 'Test') {
            initBrand()
        } else {
            setLoaded(true)
        }
        return () => {
            console.log('clean up initBrand')
        }
    }, [brands])

    const [brandsName, setBrandsName] = useState([])
    const [allCaps, setAllCaps] = useState([])
    const [list1, setList1] = useState({
            arrangedList: [[ {name: ' ', id: ''} ]],
            previousCap: ''
        })
    const [list2, setList2] = useState({
            arrangedList: [[{name: ' ', id: ''}]],
            previousCap: ''
        })
    const [list3, setList3] = useState({
            arrangedList: [[{name: ' ', id: ''}]],
            previousCap: ''
        })

    const [searchInput, setSearchInput] = useState('')

    const [selectedType, setSelectedType] = useState('ALL')

    const [selectedTag, setSelectedTag] = useState('')

    const removeDuplicates = (arr) => {
        return arr.filter((item,
                           index) => arr.indexOf(item) === index);
    }

    const reOrderList = (nameList, tagChange) => {
        let capList = []
        let alphaList = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
        let displayList = []
        if (nameList.length > 0 ) {
            if (nameList[0]['name'] !== undefined) {
                displayList = nameList.filter(item => /^[0-9]+$/.test(item['name'][0]))
            }
        }
        if (displayList.length > 0) {
            capList.push('0-9')
        }
        for (let i = 0; i< alphaList.length; i++) {
            let current = alphaList[i]
            let tempList = []
            tempList = nameList.filter(item => !!item['name'] && !!item['name'][0] ? item['name'][0].toUpperCase() === current : false)
            if (tempList !== undefined) {
                if (tempList.length > 0) {
                    capList.push(alphaList[i])
                }
            }
            displayList.push(...tempList)
        }
        if (tagChange) {
            setAllCaps(capList)
        }

        return removeDuplicates(displayList)
    }

    const arrangeList = (list, previousCap) => {
        let arrangedList = []
        let numberList = []
        let subList = []
        let cap = ''
        if (list.length > 0) {
            if (list[0]['name'] !== undefined) {
                if (list[0].length > 0) {
                    cap = list[0]['name'].substring(0, 1)
                }
            }
        }
        let checkedNumberList = false
        for ( let i = 0; i < list.length; i++) {
            let currentCap = list[i]['name'].substring(0, 1)
            if ( /^[0-9]+$/.test(currentCap) ) {
                numberList.push(list[i])
                // console.log('here: ', numberList)
                if (i === list.length - 1) {
                    arrangedList.push(numberList)
                }
            } else {
                // console.log('numberList: ', numberList)
                if (!checkedNumberList) {
                    checkedNumberList = true
                    if (numberList.length > 0) {
                        arrangedList.push(numberList)
                    }
                    cap = currentCap
                    subList.push(list[i])
                    if (i === list.length - 1){
                        arrangedList.push(subList)
                    }
                } else {
                    if (currentCap === cap) {
                        subList.push(list[i])
                        // console.log('subList', subList, list[i], currentCap, cap)
                        if (i === list.length - 1) {
                            arrangedList.push(subList)
                        }
                    } else {
                        cap = currentCap
                        arrangedList.push(subList)
                        subList = []
                        subList.push(list[i])
                    }
                }
            }
        }

        return {
            arrangedList,
            previousCap
        }
    }

    const updateList = (givenList, tagChange) => {
        let brandsList = reOrderList(givenList, tagChange)
        let length = Math.floor(givenList.length/3)
        let tempList1
        let tempList2 = {
            arrangedList: [[{name: ' ', id: ''}]],
            previousCap: ''
        }
        let tempList3 = {
            arrangedList: [[{name: ' ', id: ''}]],
            previousCap: ''
        }
        if (length > 2) {
            tempList1 = arrangeList(brandsList.slice(0, length), '')
            tempList2 = arrangeList(brandsList.slice(length, length * 2), brandsList[length]['name'].substring(0, 1))
            tempList3 = arrangeList(brandsList.slice(length * 2,), brandsList[length * 2]['name'].substring(0, 1))
        } else {
            tempList1 = arrangeList(brandsList)
        }
        setList1(tempList1)
        setList2(tempList2)
        setList3(tempList3)
    }

    const renderList = (listInfo) => {
        let list = listInfo.arrangedList
        return (
            list.map(item => {
                return (
                    <div key={item.id}>
                        {
                            <ListItem style={{ paddingBottom: 'unset', paddingTop: 'unset' }}>
                                {
                                    item[0]['name'].substring(0, 1) === listInfo.previousCap ?
                                        null :
                                        <Typography id={/^[0-9]+$/.test(item[0]['name'].substring(0, 1)) ? '0-9' : item[0]['name'].substring(0, 1)}  style={{ fontSize: 16, fontWeight: 700, fontFamily: 'Montserrat' }}>{/^[0-9]+$/.test(item[0]['name'].substring(0, 1)) ? '0-9' : item[0]['name'].substring(0, 1)}</Typography>
                                }
                            </ListItem>
                        }
                        {
                            item.map(nestedItem =>
                                    <ListItem key={nestedItem.id}  onClick={() => checkDetail(nestedItem)} >
                                        <Typography style={{ cursor: 'pointer', fontSize: 12, fontWeight: 400, color: '#333333', fontFamily: 'Montserrat' }}>{nestedItem['name']}</Typography>
                                    </ListItem>
                            )
                        }
                    </div>
                )}
            )
        )
    }

    const onChange = (e) => {
        setSearchInput(e.target.value)
    }

    const onClickFind = () => {
        let res = brandsName.filter(item => item['name'].toLowerCase().includes(searchInput.toLowerCase()))
        console.log('search res: ', res)
        if (res !== undefined) {
            updateList(res, false)
        }
    }

    const filterBrandsByType = (type) => {
        setSelectedType(type)
        if (type === 'ALL') {
            updateList(brandsName, true)
        } else {
            let filtered = brands.filter(item => item.bizType === type)
            let filteredName = filtered.map(item => {
                return {"name": item.name, "id": item.id}
            })
            updateList(filteredName, true)
        }
    }

    const handleTagClick = (tag) => {
        setSelectedTag(tag)
        let filteredName = []
        if (tag === '0-9') {
            filteredName = brandsName.filter(item => /^[0-9]+$/.test(item.name[0]))
        } else {
            filteredName = brandsName.filter(item => {
                return item.name[0] === tag
            })

        }
        updateList(filteredName, false)
    };

    const checkDetail = async (selectedBrand) => {
        let brand = brands.find(item => item.id === selectedBrand.id || item.slug === selectedBrand.id)
        console.log('found brand: ', brand)
        await router.push(`${brand.slug}/${brand.id}`)
    }

    useEffect(() => {
        if (brandsName.length > 0) {
            updateList(brandsName, true)
            return () => {
                console.log('cleaned up');
            };
        }
    }, [brandsName])

    useEffect(() => {
        console.log('at all brands: ', brands)
        if (brands.length > 0) {
            let brandsName = brands.map(item => {
                return {name: item.name, id: item.id}
            })
            if (brandsName[0]['name'] !== undefined) {
                setBrandsName(brandsName)
            }
        }
    }, [brands])



    const type = [{
        name: 'brands_product_brands',
        value: 'PRODUCT'
    }, {
        name: 'brands_service_brands',
        value: 'SERVICE'
    }, {
        name: 'brands_store_clinic_brands',
        value: 'LOCATION'
    }, {
        name: 'brands_other_brands',
        value: 'OTHERS'
    }, {
        name: 'brands_all_brands',
        value: 'ALL'
    }]

    const [isMobile, setIsMobile] = useState(false)

    useEffect(() => {
        if (loaded) {
            setIsMobile(checkMobile())
        }
    }, [loaded])

    return (
        <Wrapper>
            <div style={{ width: '100%', borderBottom: 'solid thin #DDDDDD' }}>
                <Container>
                    <MyBreadcrumbs t={t} routeList={BREAD_ROUTE}/>
                    {
                        isMobile ?
                            null :
                            <h1 style={{ letterSpacing: 3, marginTop: 30, marginBottom: 40, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: 36 }}>
                                {t('home:brandBanner1')}  <Typography sx={{ marginLeft: 2, fontWeight: 400, textTransform: 'none', fontSize: 30 }}>{t('home:footer_slogan')}</Typography>
                            </h1>
                    }
                    <nav className={isMobile ? cn('flex', 'grow', 'shrink', 'min-w-0', 'overflow-scroll', 'mt-10') : cn('flex', 'grow', 'shrink', 'min-w-0', 'overflow-hidden')}>
                        {
                            BRANDS_ROUTE.map(route => {
                                return (
                                    <Link href={route.href} key={route.label}>
                                        <a style={{ fontSize: 14, fontWeight: router.pathname === route.href ? 600 : 400,
                                            borderBottom: router.pathname === route.href ? 'solid 2px #108085' : 'unset'
                                        }}  className={
                                            isMobile ?
                                                cn(
                                                    'font-normal', 'mr-7', 'last:mr-0', 'leading-5',
                                                ) :
                                                cn(
                                                    'font-normal', 'mr-7', 'last:mr-0', 'leading-10',
                                                )
                                        }>
                                            {t(`home:${route.label}`)}
                                        </a>
                                    </Link>
                                )
                            })

                        }
                    </nav>
                </Container>
            </div>
            {
                loaded ?
                    <Container style={{ marginTop: 50 }}>
                        <div style={{ marginBottom: 20 }}>
                            <Grid container className={classes.root}>
                                <Grid xs={12} md={6} lg={3} item>
                                    <h1 style={{ fontSize: 14, fontWeight: 700, fontFamily: 'Montserrat' }}>{t('home:brands_all_brands')}</h1>
                                    <MyInput onChange={onChange} value={searchInput} handleClick={onClickFind} placeHolder={t('home:brands_find_a_brand')} margin={true}/>
                                    <div style={{ marginTop: 20 }}>
                                        <h1 style={{ fontSize: 14, fontWeight: 700, fontFamily: 'Montserrat' }}>{'A-Z'}</h1>
                                        <Grid container style={{ minHeight: 100 }}>
                                            {
                                                allCaps.map(item => {
                                                    return (
                                                        <Grid key={item} xs={2} item>
                                                            <Typography onClick={() => handleTagClick(item)}
                                                                        style={{ alignSelf: 'center', cursor: 'pointer', fontSize: 9, fontWeight: selectedTag === item ? 700 : 500, color: selectedTag === item ? '#18b8bf' : '#7C7C7C', fontFamily: 'Montserrat', lineHeight: 3 }}>{item}
                                                            </Typography>
                                                        </Grid>
                                                    )
                                                })
                                            }
                                        </Grid>
                                    </div>
                                    <div style={{ marginTop: 20 }}>
                                        <h1 style={{ fontSize: 14, fontWeight: 700, fontFamily: 'Montserrat' }}>{t('home:product_browsebycategory')}</h1>
                                        <div className={isMobile ? 'flex grid grid-cols-2 gap-3' : null}>
                                            {
                                                type.map(item =>
                                                    <Typography onClick={() => filterBrandsByType(item.value)} key={item.name} style={{ fontSize: 12, fontWeight: selectedType === item.value ? 700 : 400, color: selectedType === item.value ? '#18b8bf' : '#333333', fontFamily: 'Montserrat', lineHeight: 2, cursor: 'pointer' }}>{t(`home:${item.name}`)}</Typography>
                                                )
                                            }
                                        </div>

                                    </div>
                                </Grid>
                                {
                                    list1.arrangedList.length > 0 ?
                                        <Grid className={isMobile ? 'mt-5' : null} item xs={12} md={6} lg={list2.arrangedList.length > 0 ? list3.arrangedList.length > 0 ? 3 : 4 : 6}>
                                            <List className={isMobile ? classes.mobileList : classes.list}>
                                                {renderList(list1)}
                                            </List>
                                        </Grid> : null
                                }
                                {
                                    list2.arrangedList.length > 0 ?
                                        <Grid item xs={12} md={6} lg={list3.arrangedList.length > 0 ? 3 : 4}>
                                            <List className={isMobile ? classes.mobileList : classes.list}>
                                                {renderList(list2)}
                                            </List>
                                        </Grid> :  null
                                }
                                {
                                    list3.arrangedList.length > 0 ?
                                        <Grid item xs={12} md={6} lg={3}>
                                            <List className={isMobile ? classes.mobileList : classes.list}>
                                                {renderList(list3)}
                                            </List>
                                        </Grid> : null
                                }
                            </Grid>

                        </div>
                    </Container> :
                    <Container style={{ marginTop: 50 }}>
                        <span>{t('home:loading')}</span>
                    </Container>
            }
        </Wrapper>
    )
}

AllBrands.getLayout = function getLayout(page) {
    return (
        <DefaultLayout>
            {page}
        </DefaultLayout>
    )
}
